import { GroupByOption, StoredMetric } from "../common-tile.model";

export class ChartMetric {
  color: string;
  stack: string;
  lineType: string = '';
  metric: StoredMetric;

  constructor(color?: string, metric?: StoredMetric, stack?: string, lineType?: string) {
    this.stack = stack;
    this.color = color;
    this.metric = metric;
    this.lineType = lineType;
  }
}

export class StoredChartTileDefinition {
  header: string;
  groupBy: GroupByOption;
  lineMetrics: ChartMetric[];
  barMetrics: ChartMetric[];

  constructor(
    header: string,
    groupBy: GroupByOption,
    lineMetrics: ChartMetric[] = [],
    barMetrics: ChartMetric[] = []
  ) {
    this.header = header;
    this.groupBy = groupBy;
    this.lineMetrics = lineMetrics;
    this.barMetrics = barMetrics;
  }
}
